import {
  Environment,
  middlewareTypes,
  createFetchPolicyMiddleware,
  createErrorMiddleware,
  Store,
} from '@bingads-webui-react/overreact';
import { schema } from './schema';

export { getRequestor } from './requestor';

const middlewares = {
  [middlewareTypes.FETCH_POLICY]: createFetchPolicyMiddleware(),
  [middlewareTypes.ERROR]: createErrorMiddleware(),
};

// TODO: do we really need to export this Store from overreact?
const store = new Store();
let env = null;

export const SMART_ENVIRONMENT_TAG = 'Smart_Endpoint';

export function getEnvironmentInstance(requestor, extraMiddleware = {}) {
  if (!env) {
    env = new Environment(requestor, schema, store, {
      ...middlewares,
      ...extraMiddleware,
    }, SMART_ENVIRONMENT_TAG);
  }

  return env;
}

export function environmentLookupFn(environmentTag) {
  return environmentTag === SMART_ENVIRONMENT_TAG;
}
